import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { faCircleDot } from '@fortawesome/pro-regular-svg-icons/faCircleDot';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons/faCircleCheck';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import { useQuizContext } from '../../../../context/QuizContext';
import { MatrixData } from '../../../../types/quiz';
import { P } from '@osmosis/react-ui/components/Text';
import { optionType } from './Matrix';

const GridItem = ({
  col,
  row,
  correctValue,
  checkedOptions,
}: {
  col: number;
  row: number;
  correctValue: string;
  checkedOptions: optionType;
}) => {
  const { isAnswered } = useQuizContext();

  const colors = useColors();

  if (isAnswered && Number(correctValue) === col) {
    return <Icon icon={faCircleCheck} color={colors.positive} />;
  }

  if (checkedOptions[row] === col) {
    return <Icon icon={faCircleDot} color={colors.primary} />;
  }

  return <Icon icon={faCircle} color={colors.gray40} />;
};

/**
 * Row for matrix.
 */
const MatrixRows = ({
  checkedOptions,
  handleChoice,
}: {
  checkedOptions: optionType;
  handleChoice: (row: number, col: number) => void;
}) => {
  const { currentItem, isAnswered } = useQuizContext();
  const currentData = currentItem?.data as MatrixData;
  return (
    <>
      {currentData.answers.rows.map(({ name, correctValue }, row) => (
        <Box as="tr" key={name}>
          <>
            <Box as="td" sx={{ border: 'none' }}>
              {isAnswered && Number(correctValue) === checkedOptions[row] && (
                <Box sx={{ position: 'absolute', left: '15px' }}>
                  <Icon icon={faCheck} fontSize="20px" color="green" />
                </Box>
              )}

              <P fontSize="14px">{name}</P>
            </Box>
            {currentData.answers.columns.map(({ name }, col) => (
              <Box
                as="td"
                onClick={() => handleChoice(row, col)}
                key={name}
                sx={{ cursor: 'pointer', border: 'none' }}
                data-testid="matrix-row-item"
              >
                <Flex alignItems="center" justifyContent="center">
                  <GridItem
                    col={col}
                    row={row}
                    correctValue={correctValue}
                    checkedOptions={checkedOptions}
                  />
                </Flex>
              </Box>
            ))}
          </>
        </Box>
      ))}
    </>
  );
};

export default MatrixRows;
